export default function Spinner() {
  return (
    <svg
      className="-ml-1 mr-3 h-8 w-8 animate-spin text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
      />

      <circle
        className="opacity-75"
        cx="12"
        cy="12"
        r="10"
        stroke="#00EBFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="31.4 62.8"
        strokeDashoffset="0"
        fill="none"
      />
    </svg>
  )
}
